module.exports = "<div class=\"app-body\">\r\n  <div menu class=\"sidebar\"></div>\r\n    <!-- Main content -->\r\n    <main class=\"main\">\r\n        <!-- Breadcrumb -->\r\n        <ol class=\"breadcrumb\">\r\n            <breadcrumbs></breadcrumbs>\r\n        </ol>\r\n\r\n        <div class=\"container-fluid\">\r\n            <router-outlet></router-outlet>\r\n        </div>\r\n        <!-- /.conainer-fluid -->\r\n    </main>\r\n    <aside class=\"aside-menu\"></aside>\r\n</div>\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/roche/roche/src/app/layouts/body/body.component.html
// module id = ../../../../../src/app/layouts/body/body.component.html
// module chunks = main